var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-block-list-infogram",attrs:{"id":("block-" + (_vm.$vnode.key))}},[(_vm.title && _vm.showTitleInToc)?_c('LongReadTarget',{staticClass:"relative",attrs:{"link-to-toc":{
			name: ("Spring til \"" + _vm.title + "\" i indholdsfortegnelsen"),
			attrs: {
				'data-focus-ignore': true,
			},
		},"container-id":("block-" + (_vm.$vnode.key)),"title":_vm.title}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"c-block-list-infogram__embed max-w-full",class:[
			{
				'w-full': !_vm.turnOffScale,
			},
			'infogram-embed' ],attrs:{"data-id":_vm.infogramId,"data-type":"interactive","data-title":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }